"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
const colors_1 = require("./colors");
exports.config = {
    theme: {
        borderRadius: {
            sm: '4px',
            md: '8px',
            lg: '10px',
            full: '9999px',
            none: '0px',
        },
        colors: colors_1.colors,
    },
};
